import { moduleProviderFactory } from 'core/providers';
import { MissingDocumentEdit, MissingDocumentList } from 'application/missing-document/pages';

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: 'master.app.main.missing-document',
                pattern: '/missing-documents',
                children: [
                    {
                        name: 'master.app.main.missing-document.list',
                        pattern: '',
                        tabTitle: 'MISSING_DOCUMENT.LIST.TITLE_SECONDARY',
                        component: MissingDocumentList,
                        data: {
                            title: 'MISSING_DOCUMENT.LIST.TITLE_SECONDARY'
                        }
                    },
                    {
                        name: 'master.app.main.missing-document.create',
                        pattern: '/create',
                        tabTitle: 'Create Missing Document',
                        component: MissingDocumentEdit,
                        authorization: 'importReferenceSection.create',
                        data: {
                            title: 'MISSING_DOCUMENT.CREATE.TITLE'
                        },
                    },
                    {
                        name: 'master.app.main.missing-document.edit',
                        pattern: '/edit/:id',
                        tabTitle: 'Edit Missing Document',
                        component: MissingDocumentEdit,
                        authorization: 'importReferenceSection.update',
                        data: {
                            title: 'MISSING_DOCUMENT.EDIT.TITLE'
                        },
                    }                 
                ]
            }
        ],
        menu: [
            {
                title: 'MENU.MASTER_DATA',
                order: 7,
                icon: 'database',
                authorization: 'administrationSection.read',
                subMenu: [
                    {
                        title: 'Missing Documents',
                        route: 'master.app.main.missing-document.list',
                        order: 7,
                    }                    
                ]
            }
        ]
    });
})();
